import { Parser } from "@siteimprove/alfa-parser";
import { Function as CSSFunction } from "../../syntax/index.js";
import { List } from "../collection/index.js";
import { Number } from "../numeric/index.js";
import { Function } from "./function.js";
const { map, either } = Parser;
/**
 * @public
 */
export class Matrix extends Function {
    static of(...values) {
        return new Matrix(values.map((row) => row.map((value) => value.resolve())));
    }
    _values;
    constructor(values) {
        super("matrix", false);
        this._values = values;
    }
    get values() {
        return this._values;
    }
    resolve() {
        return this;
    }
    equals(value) {
        return (value instanceof Matrix &&
            value._values.every((row, i) => row.every((value, j) => value.equals(this._values[i][j]))));
    }
    hash(hash) {
        for (const row of this._values) {
            for (const number of row) {
                hash.writeHashable(number);
            }
        }
    }
    toJSON() {
        return {
            ...super.toJSON(),
            values: this._values.map((row) => row.map((value) => value.toJSON())),
        };
    }
    toString() {
        const [[a, e, i, m], [b, f, j, n], [c, g, k, o], [d, h, l, p]] = this._values;
        if (c.value === 0 &&
            d.value === 0 &&
            g.value === 0 &&
            h.value === 0 &&
            i.value === 0 &&
            j.value === 0 &&
            k.value === 1 &&
            l.value === 0 &&
            o.value === 0 &&
            p.value === 1) {
            return `matrix(${[a, b, e, f, m, n].join(", ")})`;
        }
        return `matrix3d(${[a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p].join(", ")})`;
    }
}
/**
 * @public
 */
(function (Matrix) {
    function isMatrix(value) {
        return value instanceof Matrix;
    }
    Matrix.isMatrix = isMatrix;
    const _0 = Number.of(0);
    const _1 = Number.of(1);
    const parseValues = (name, quantity) => CSSFunction.parse(name, map(List.parseCommaSeparated(Number.parse, quantity, quantity), (list) => list.values));
    /**
     * {@link https://drafts.csswg.org/css-transforms/#funcdef-transform-matrix}
     */
    const parseMatrix = map(parseValues("matrix", 6), (result) => {
        const [_, [_a, _b, _c, _d, _e, _f]] = result;
        return Matrix.of([_a, _c, _0, _e], [_b, _d, _0, _f], [_0, _0, _1, _0], [_0, _0, _0, _1]);
    });
    /**
     * {@link https://drafts.csswg.org/css-transforms-2/#funcdef-matrix3d}
     */
    const parseMatrix3d = map(parseValues("matrix3d", 16), (result) => {
        const [_, [_a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p],] = result;
        return Matrix.of([_a, _e, _i, _m], [_b, _f, _j, _n], [_c, _g, _k, _o], [_d, _h, _l, _p]);
    });
    Matrix.parse = either(parseMatrix, parseMatrix3d);
})(Matrix || (Matrix = {}));
//# sourceMappingURL=matrix.js.map